import api from './api';
import { getStatusIcon as statusIconHelper } from '../utils/statusHelpers';

export const applyToJob = async (jobId, data = {}) => {
  try {
    const formData = new FormData();
    if (data.coverLetter) formData.append('coverLetter', data.coverLetter);
    if (data.resumePath) formData.append('resumePath', data.resumePath);
    if (data.resumeFile) formData.append('resumeFile', data.resumeFile);

    const response = await api.post(`applications/job/${jobId}/apply`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    // FIXED: Return response.data (ApiResponse wrapper) 
    // so JobApplicationModal can check response.success flag.
    return response.data;
  } catch (error) {
    console.error('Error applying for job:', error);
    throw error;
  }
};

export const getMyApplications = async () => {
  try {
    const response = await api.get('applications/my-applications');
    return response.data;
  } catch (error) {
    console.error('Error fetching my applications:', error);
    throw error;
  }
};

export const getRecruiterApplications = async () => {
  try {
    const response = await api.get('applications/recruiter/applications');
    return response.data;
  } catch (error) {
    console.error('Error fetching recruiter applications:', error);
    throw error;
  }
};

export const getRecruiterStatistics = async () => {
  try {
    const response = await api.get('applications/recruiter/statistics');
    return response.data;
  } catch (error) {
    console.error('Error fetching recruiter statistics:', error);
    throw error;
  }
};

export const getApplicationStatus = async (jobId) => {
  try {
    const response = await api.get(`applications/status/${jobId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching application status:', error);
    throw error;
  }
};

export const updateApplicationStatus = async (applicationId, statusData) => {
  try {
    const response = await api.put(`applications/${applicationId}/status`, statusData);
    return response.data;
  } catch (error) {
    console.error('Error updating application status:', error);
    throw error;
  }
};

export const withdrawApplication = async (applicationId) => {
  try {
    // FIXED: Backend uses PUT /api/applications/{id}/withdraw
    const response = await api.put(`applications/${applicationId}/withdraw`);
    return response.data;
  } catch (error) {
    console.error('Error withdrawing application:', error);
    throw error;
  }
};

export const deleteApplication = async (applicationId) => {
  try {
    const response = await api.delete(`applications/${applicationId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting application:', error);
    throw error;
  }
};

// Bridge function to prevent "service.getStatusIcon is not a function"
export const getStatusIcon = (status) => statusIconHelper(status);

export const isStatusEditable = (status) => {
  // Statuses that can be changed by recruiters
  return !['WITHDRAWN'].includes(status);
};

export const getNextPossibleStatuses = (currentStatus) => {
  const transitions = {
    'APPLIED': ['UNDER_REVIEW', 'REJECTED'],
    'UNDER_REVIEW': ['INTERVIEW_SCHEDULED', 'REJECTED'],
    'INTERVIEW_SCHEDULED': ['INTERVIEWED', 'REJECTED'],
    'INTERVIEWED': ['OFFERED', 'REJECTED'],
    'OFFERED': ['HIRED', 'REJECTED'],
    'HIRED': [], // Terminal state
    'REJECTED': [], // Terminal state
    'WITHDRAWN': [] // Terminal state
  };
  return transitions[currentStatus] || [];
};

/**
 * Get the resume download URL for an application.
 * Used by recruiters to download applicant resumes.
 */
export const getResumeDownloadUrl = (applicationId) => {
  if (!applicationId) return null;
  return `/api/resume/download/${applicationId}`;
};

export const applicationService = {
  applyToJob,
  getMyApplications,
  getRecruiterApplications,
  getRecruiterStatistics,
  getApplicationStatus,
  updateApplicationStatus,
  withdrawApplication,
  deleteApplication,
  getStatusIcon,
  isStatusEditable,
  getNextPossibleStatuses,
  getResumeDownloadUrl
};

export default applicationService;